/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-10-04T17:20:26+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-04T17:31:28+02:00
*/


/**
 * calculates if a field should show its error
 * @param  {Boolean/Function} showErrors
 *         function, which returns, if the error should be shown
 *         or simply a boolean value
 * @param  {Object} props
 *         props passed to mapProps of a react-redux-store Control
 *         see: https://davidkpiano.github.io/react-redux-form/docs/api/Control.html#mapprops
 * @return {Boolean}
 *         if the field should be in error state
 */
function shouldShowErrors(showErrors, props) {
  if (
    showErrors === true
        || (typeof showErrors === 'function' && showErrors(props.fieldValue))
  ) {
    return !props.fieldValue.valid;
  }
  return false;
}
export default shouldShowErrors;

